
import React from 'react';

//components
import WmsGrid from './../../components/WmsGrid/WmsGrid.jsx';
import WmsCollapse from './../../components/WmsCollapse/WmsCollapse.jsx';
import { NewCarrierConnectionModel } from './model/new-carrier-connection.component.jsx';
import DynamicCarrierConnectionModel from './model/dynamic-carrier-connection.component.tsx';
import DynamicProviderConnectionModel from './model/dynamic-provider-connection.component.tsx';

import { StringWms } from './../../../../assets/ts/StringWms.ts';
import * as GridConfig from './small-parcel-carrier-account-grid-config.jsx';
//services
import * as GlobalService from './../../global_services';
import * as smallParcelServices from './../small-parcel-settings.services.jsx';

export class SmallParcelCarrierAccountSettings extends React.Component {

    constructor(props) {

        super(props);

        this.rights = GlobalService.GetRights();
        this.isEnableProvider = this.rights.hasOwnProperty('Shipping.SmallParcelEnabled') && this.rights['Integrations.SmallParcelPartner'] == 'ParcelApi';
        this.dynamicCarrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();
        this.translate = window.translate;
        this.$rootScope = window;
        let carrier_GridHeaders = StringWms.convertSringToOption(this.translate('Small_Parcel_Carrier_Header'));
        this.carrierGridColumns = GridConfig.getCarrierGridColumnsColumns(carrier_GridHeaders, this.isEnableProvider, this.props.sharedSmallParcelSettings, this.dynamicCarrierAccountSchema).columns;
        this.carrierGridSchema = GridConfig.getCarrierGridSchema().schema;
        this.localKendoGrid = null;

        this.state = {
            isOpenCarrierConnectionModel: false,
            isOpenProviderConnectionModel: false,
            sharedCarrierConnectionFlow: '',
            selectedCarrierAccountData: null,
            deleteCarrierLoader: false,
            isUpdateGridSummary: false,
            isEditCarrierDisable: true
        };
        document.removeEventListener("CallEditCarrierFromMarkup", this.editCarrierFromMarkup, true); // Succeeds
        document.addEventListener("CallEditCarrierFromMarkup", this.editCarrierFromMarkup);
    }
    editCarrierFromMarkup = (data) => {
        let gridData = $("#CarrierGrid").data("kendoGrid").dataSource._data;
        var itemObj = _.filter(gridData, function (p) {
            return (data.detail == p.RowNumber);
        });
        this.setState({
            selectedCarrierAccountData: itemObj[0],
            isOpenCarrierConnectionModel: true,
            sharedCarrierConnectionFlow: 'edit'
        });
    }

    addCarrierConnection = () => {
        this.setState({
            isOpenCarrierConnectionModel: true,
            sharedCarrierConnectionFlow: 'create'
        });
    }
    addProviderConnection = () => {
        this.setState({
            isOpenProviderConnectionModel: true,
        });
    }

    editCarrierConnection = () => {
        this.setState({
            isOpenCarrierConnectionModel: true,
            sharedCarrierConnectionFlow: 'edit'
        });
    }
    closeCarrierConnection = () => {
        this.setState({ isOpenCarrierConnectionModel: false });
    }
    closeProviderConnection = () => {
        this.setState({ isOpenProviderConnectionModel: false });
    }

    deleteCarrier = () => {
        this.setState({ deleteCarrierLoader: true });

        let carrierAccountUri = this.state.selectedCarrierAccountData.Uri;

        smallParcelServices.deleteCarrier(carrierAccountUri).then((response) => {
            GlobalService.notification('success', this.translate('Label_CarrierAccount_Deleted'));
            this.onResetSelectionAndGridRefresh();
        }).finally(() => {
            this.setState({ deleteCarrierLoader: false });
        });
    }
    onResetSelectionAndGridRefresh = () => {

        if (this.localKendoGrid != null) {
            this.localKendoGrid.clearSelections(() => {
                this.localKendoGrid.repaintSelections();
            });
            this.setState({
                selectedCarrierAccountData: null,
                isEditCarrierDisable: true,
                isUpdateGridSummary: true
            });
        }
        this.props.onRefreshGridData();
    }

    selectRow = (param_kendo_grid) => {

        let currentSelections = param_kendo_grid.getNumberOfSelections();
        let selectedCarrierAccountData = null;
        let isEditCarrierDisable = true;

        if (currentSelections === 1) {
            selectedCarrierAccountData = param_kendo_grid.getItem(param_kendo_grid.getKeys());
            isEditCarrierDisable = false;
        }
        this.localKendoGrid = param_kendo_grid;
        this.setState({
            selectedCarrierAccountData: selectedCarrierAccountData,
            isEditCarrierDisable: isEditCarrierDisable
        });
    }
    onUpdateGridSummary = () => {
        this.setState({ isUpdateGridSummary: false });
    }
    onGridSave = (e) => {
        var model = e.model;
        if (e.values.MarkupAmmount) {
            model.set("MarkupPercentage", 0);
        } else if (e.values.MarkupPercentage) {
            model.set("MarkupAmmount", 0);
        }
    }
    render() {

        return (

            <div className="carrier-account-settings-wrapper">
                <WmsCollapse
                    id={'smallParcelSettingsCarrierAccounts'}
                    headerLabel={this.translate('Label_Carrier_Accounts')}
                    showCollapseText={false}
                    showCollapseIcon={true}>


                    <div className="manage-carrier-grid-holder">
                        <WmsGrid
                            columns={this.carrierGridColumns}
                            schema={this.state.carrierGridSchema}
                            gridKeySelection={'RowNumber'}
                            staticGridData={this.props.sharedCarrierAccountsGridData}
                            virtual={false}
                            showGridSummary={true}
                            gridName={"CarrierGrid"}
                            id={"CarrierGrid"}
                            windowId={this.props.windowId}
                            showGridResult={true}
                            showSortColumns={true}
                            showColumnFilter={false}
                            shawCheckbox={false}
                            wmsSelector={this.props.selector + "CarrierGrid"}
                            onSelection={this.selectRow}
                            onSelectAllChange={() => null}
                            clickEventOfContextMenu={() => { }}
                            resetButtonLabel={this.translate('Label_Options')}
                            resetButtonIcon={'fa-sliders'}
                            isUpdateGridSummary={this.state.isUpdateGridSummary}
                            onUpdateGridSummary={this.onUpdateGridSummary}
                            onGridSave={this.onGridSave}
                            menu={
                                [
                                {
                                    "name": this.translate('Label_Create'),
                                    "value": [
                                        {
                                            "name": this.translate("Label_New_carrier"),
                                            "wmsSelector": this.props.selector + "newCarrier",
                                            "value": [],
                                            "onClickFunc": this.addCarrierConnection,
                                            "disabledText": "",
                                            "isContextMenu": true,
                                            "isButtonMenu": true,
                                            "wmsid": "NewCarrier",
                                        },
                                        {
                                            "name": this.translate("Label_New_provider"),
                                            "wmsSelector": this.props.selector + "newProvider",
                                            "value": [],
                                            "onClickFunc": this.addProviderConnection,
                                            "isContextMenu": true,
                                            "isButtonMenu": true,
                                            "wmsid": "NewProvider",
                                        },
                                    ],
                                    // "disabled": !this.props.sharedSelectedCustomer.id,
                                    "icon": "fa-plus",
                                    "color": "green",
                                    'isContextMenu': false,
                                    'isButtonMenu': true,
                                    'wmsid': 'create',
                                    'wmsSelector': this.props.selector + "CreateCarrier",
                                }, {
                                    "name": this.translate('Label_Edit'),
                                    "value": [],
                                    "disabled": this.state.isEditCarrierDisable,
                                    "showToolTip": (this.state.selectedCarrierAccountData != null),
                                    "tooltipText": this.translate('Carrier_EDIT_DISABLE_TEXT'),
                                    "icon": "fa-pencil",
                                    "color": "green",
                                    'isContextMenu': false,
                                    'isButtonMenu': true,
                                    'wmsid': 'edit',
                                    'wmsSelector': this.props.selector + "EditCarrier",
                                    'clickFunc': this.editCarrierConnection,
                                },{
                                    "name": this.translate('Label_Delete'),
                                    "value": [],
                                    "icon": "fa-trash",
                                    "color": "red",
                                    'isContextMenu': false,
                                    'isButtonMenu': true,
                                    'wmsid': 'expandCollapse',
                                    'wmsSelector': this.props.selector + "ExpandCarrier",
                                    'clickFunc': this.deleteCarrier,
                                    'loading': this.state.deleteCarrierLoader,
                                    "disabled": (this.state.selectedCarrierAccountData == null)
                                }]
                            }
                        />
                    </div>
                    {this.state.isOpenCarrierConnectionModel && (
                        <>
                            <DynamicCarrierConnectionModel
                                isOpenCarrierConnectionModel={this.state.isOpenCarrierConnectionModel}
                                sharedSelectedCarrierAccountData={this.state.selectedCarrierAccountData}
                                sharedCarrierConnectionFlow={this.state.sharedCarrierConnectionFlow}
                                closeCarrierConnection={this.closeCarrierConnection}
                                sharedFacilityOption={this.props.sharedFacilityOption}
                                onResetSelectionAndGridRefresh={this.onResetSelectionAndGridRefresh}
                                sharedShipEngineCarrier={this.props.sharedShipEngineCarrier}
                                sharedSelectedCustomer={this.props.sharedSelectedCustomer}
                                selector={this.props.selector} />
                        </>
                    )}
                    {this.state.isOpenProviderConnectionModel && (
                            <DynamicProviderConnectionModel
                                isOpenCarrierConnectionModel={this.state.isOpenProviderConnectionModel}
                                sharedSelectedCarrierAccountData={this.state.selectedCarrierAccountData}
                                sharedCarrierConnectionFlow={this.state.sharedCarrierConnectionFlow}
                                closeCarrierConnection={this.closeProviderConnection}
                                sharedFacilityOption={this.props.sharedFacilityOption}
                                onResetSelectionAndGridRefresh={this.onResetSelectionAndGridRefresh}
                                sharedShipEngineCarrier={this.props.sharedShipEngineCarrier}
                                sharedSelectedCustomer={this.props.sharedSelectedCustomer}
                                selector={this.props.selector} />
                    )}
                </WmsCollapse>
            </div >
        );
    }
}